import { render, staticRenderFns } from "./suggestions.vue?vue&type=template&id=7c68dde1&scoped=true&"
import script from "./suggestions.vue?vue&type=script&lang=js&"
export * from "./suggestions.vue?vue&type=script&lang=js&"
import style0 from "./suggestions.vue?vue&type=style&index=0&lang=css&"
import style1 from "./suggestions.vue?vue&type=style&index=1&id=7c68dde1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c68dde1",
  null
  
)

export default component.exports